import { Text, View } from "@react-pdf/renderer";
import { textStyles, toWords } from "../../common";

export default function TotalAmountInWords({
    grandTotal,
}: {
    grandTotal: number;
}) {
    return (
        <View
            style={{
                display: "flex",
                flexDirection: "column",
                marginTop: 10,
                width: "100%",
            }}
        >
            <View
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <Text style={{ color: "#7D7D7D" }}>Total ( in Words )</Text>
                <Text
                    style={{
                        ...textStyles.arabicText,
                        color: "#7D7D7D",
                    }}
                >
                    المجموع كتابةً
                </Text>
            </View>
            <Text
                style={{
                    marginTop: "5px",
                    fontWeight: 800,
                }}
            >
                {toWords.convert(Number(grandTotal))}
            </Text>
        </View>
    );
}
